import { Component, OnInit } from '@angular/core';
import { TranslateManager } from './core/translate';

@Component({
    selector: 'app',
    template: require('./app.component.html')
})
export class AppComponent implements OnInit {

    constructor(private translateManager: TranslateManager) {
    }

    ngOnInit() {
        this.translateManager.configure();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/app.component.ts